import React from 'react'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import './Home.css'
import frontImage from './clinica-front.jpg'
import promoImage from './promo-image.jpg'
import TitleContentSection from '../titlecontentsection/TitleContentSection'
import MessageBox from '../messagebox/MessageBox'
import BaseComponent from '../basecomponent/BaseComponent'

const boxes = [
    {
        title: "Somos",
        text: "Somos un clínica establecida en Igualada desde hace más de 25 años. Y estamos orgullosos de poder emplear esta experiencia en el trato a nuestros pacientes, que con su fidelidad nos permiten seguir ayudándoles en el tratamiento de su salud bucal."
    },
    {
        title: "Finalidad",
        text: "La finalidad de nuestro trabajo siempre será el poder aconsejar y realizar a nuestros pacientes los tratamientos más acertados según sus necesidades y posiblidades. Preocupándonos constantemente en nuestra formación para así poder revertir nuestros conocimientos en su beneficio y satisfacción."
    },
    {
        title: "Personal",
        text: "Los profesionales que integramos el equipo humano de nuestra consulta, formado por especialistas en Estomatología, Cirugía Bucal, Ortodoncia e Higienistas, sin olvidar al Personal Auxiliar y Administrativo, que en todo momento estará dispuesto a ayudarle para facilitar cualquier tratamiento o servicio que usted necesite."
    }
]

const Pic = (props) => (
    <div className="Home-Image">
        <img src={props.src} alt={props.alt} />
        {/*<h4 className="pic-legend">{props.title}</h4>*/}
    </div>
)

const PhotoCarousel = () => (
    <div className="Home-Carousel-Container">
        <div className="Home-Carousel">
            <Pic src={frontImage} title="CLINICA DENTAL BALMES" alt="Clínica" />
        </div>
    </div>
)

const MessageBoxesSection = (props) => (
    <div className="Home-MessageBox-Container">
        { props.items.map( e => (
                <div key={e.title} className="Home-MessageBox-Item">
                    <MessageBox title={e.title}>
                        <p className="Home-MessageBox-Content">{e.text}</p>
                    </MessageBox>
                </div>
            )
        ) }
    </div>
)

const HomeComponent = () => (

    <div className="Home">
        <PhotoCarousel />
        <TitleContentSection title="Más de 25 años de experiencia a su servicio">
            <h3 className="Section-Content">La mejor calidad a los mejores precios<br />Consulte condiciones de financiación</h3>
        </TitleContentSection>
        <img className="PromoImage" src={promoImage} alt="Imagen promocional" />
        <MessageBoxesSection items={boxes} />

    </div>
)

const Home = BaseComponent(HomeComponent, "Home")

export default Home



// WEBPACK FOOTER //
// ./src/components/home/Home.js